import { createElement as h } from "react"

import { Menu, MenuItem } from "@mui/material"
import { styled } from "@mui/material/styles"

export const Item = styled((props) => h(MenuItem, { ...props }))(
  ({
    theme: {
      palette,
      typography: { pxToRem },
    },
  }) => ({
    "&:hover": { backgroundColor: "#f2f2f2" },
    "&:last-child": { borderBottom: "none" },
    borderBottom: "1px solid #ebebeb",
    color: palette.secondary.contrastText,
    fontSize: pxToRem(14),
    fontWeight: "bold",
    minWidth: pxToRem(230),
    padding: `${pxToRem(12)} ${pxToRem(20)}`,
  }),
)

export const Root = styled((props) => h(Menu, { ...props }))(({ maxheight, menugap }) => ({
  "& .MuiPaper-root": {
    "& .MuiMenu-list": {
      padding: 0,
    },
    border: "1px solid #ebebeb",
    marginTop: menugap,
    maxheight,
    top: 0,
  },
}))
